import { Auth0Provider } from "@developertown/oidc-provider";
import React from "react";
import { clearAccessToken } from "./api/api";
import { CustomWindow } from "./env";
import { defaultRoutes } from "./ui/routes";

const AuthenticationProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const runtime: CustomWindow = window;
  return (
    <Auth0Provider
      domain={runtime.env?.REACT_APP_AUTH0_DOMAIN || "not set"}
      audience={runtime.env?.REACT_APP_AUTH0_AUDIENCE || "not set"}
      clientId={runtime.env?.REACT_APP_AUTH0_CLIENT_ID || "not set"}
      redirectUri={window.location.origin}
      useRefreshTokens={true}
      onAccessTokenChanged={(token) => {
        // eslint-disable-next-line no-console
        console.debug(
          "Access token valid until:",
          token.expiresAt ? new Date(token.expiresAt * 1000).toLocaleTimeString() : "unknown",
        );
      }}
      onAccessTokenExpiring={() => {
        // eslint-disable-next-line no-console
        console.debug("Access token is expiring soon.");
      }}
      onAccessTokenExpired={() => {
        // eslint-disable-next-line no-console
        console.warn("Access token has expired.");
        clearAccessToken();
        window.location.href = defaultRoutes.path;
      }}
      onAccessTokenRefreshError={(error: Error) => {
        // eslint-disable-next-line no-console
        console.error("Error refreshing access token:", error);
      }}
      extraQueryParams={{
        audience: runtime.env?.REACT_APP_AUTH0_AUDIENCE || "not set",
        organization: runtime.env?.REACT_APP_AUTH0_ORGANIZATION,
      }}
    >
      {children}
    </Auth0Provider>
  );
};

export default AuthenticationProvider;
